// extracted by mini-css-extract-plugin
export default {"modalContent":"style_modalContent__gFvb0","title":"style_title__mPoRB","description":"style_description__ZHSZC","infoIcon":"style_infoIcon__n6clY"};